import React, {useEffect, useRef, useState} from "react";
import axios from 'axios';
import MyLoader from "../../sharecomponents/MyLoader";
import {API_URL,  PHP_API} from "../../../utils/Common";

import CantidadFlorPlan from "./CantFlorPlan";
import Modal from "../../sharecomponents/Modal";
import PorcentajeVariedad from "./PorcentajeVariedad";
import PorcentajeColor from "./PorcentajeColor";

const FlorPlanporcentajes = (props) => {
    const currentYear = (new Date()).getFullYear();
    // -- loader
    const [loader, updateLoader] = useState(false);
    // -- flores para agregar una nueva flor al sistema
    const [flores, setFlores] = useState([]);
    const [years, setYears] = useState([]);
    const [flor, setFlor] = useState({ flor: 0, year: currentYear });
    const [planes, setPlanes] = useState([]);
    // const [showVar, setShowVar] = useState(false);
    //const [showCol, setShowCol] = useState(false);
    const modalRef = useRef();
    let florId = 0;
    let year = 0;
    var keycont = 965874155;

  const keyGet = () =>{
    //Genera los diferentes keys de los elementos generados de manera iterativa
    keycont++;
    return keycont;
  }

    useEffect(() => {
        getFlores();
    }, []);

    function getFlores() {
        updateLoader(true);
        console.log("se obtienen flores")
        axios.get(PHP_API + 'flor/getFlores')
            .then(r => {
                console.log("respuesta flores",r.data)
                setFlores(r.data.flores);
                setYears(r.data.years);
                updateLoader(false);
                getPlanData(); // esta en esta posición solo para probar!
            }).catch(e => console.log(e));
    }

    const getPlanData = () => {
        updateLoader(true);
        axios.get(PHP_API + 'getPlanPorFlor')
            .then(r => {
                console.log(r.data);
                setPlanes(r.data.data);
                updateLoader(false);
            })
            .catch(e => console.log(e));
    }

    const onChange = (e) => {
        setFlor({
            ...flor,
            [e.target.name]: e.target.value,
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        console.log(flor);
        updateLoader(true);
        axios.post(API_URL + '/setplanflor', { ...flor })
            .then(r => {
                console.log(r);
                updateLoader(false);
                getFlores();
            }).catch(e => console.log(e));
    }

    const showRemoverMdl = (f, y) => {
        florId = f.florId;
        year = y;
        console.log(florId, year);
        modalRef.current.showModal();
    }

    const remover = () => {
        modalRef.current.hideModal();
        console.log(florId, year);
        updateLoader(true);
        axios.post(API_URL + '/removerPlanFlor', {florId, year})
            .then(r => {
                console.log(r);
                updateLoader(false);
                getFlores();
            });
    }

    const recalcularPlanSiembra = () => {
        updateLoader(true);
        axios.get(PHP_API + 'recalcular')
            .then(r => {
                console.log(r.data);
                updateLoader(false);
            });
    }

    const modificarTotalesFlor = (cantidad, i, j) => {
        console.log(cantidad, i, j);
    }

    const updateShowVar = (x, j) => {
        planes[x].flores[j].show = !planes[x].flores[j].show;
        setPlanes([...planes]);
    }

    const updateShowCol = (x, j, l) => {
        planes[x].flores[j].variedades[l].show = !planes[x].flores[j].variedades[l].show;
        setPlanes([...planes]);
    }

    return (
        <>
        <div className="w-full p-3 right-0">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    {/*<h5 className="font-bold uppercase text-white">Plan de Cosecha</h5>
                    <p className="text-white text-sm">Definición del Plan de Cosecha a nivel Flor</p> */}
                </div>
                <div className="p-5 rounded-b">
                    {/* ---- Formulario seleccionar flor --- */}
                    <form onSubmit={onSubmit}>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            {/** seleccionar el año */}
                            <div className="w-full md:w-1/12 mb-6 mr-1 md:mb-0">
                                <div className="relative">
                                    <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            name="year"
                                            onChange={onChange}>
                                        {
                                            years.map((y, i) => {
                                                return (
                                                    <option key={keyGet()} value={y.year}>{ y.year }</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 20 20">
                                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            {/** seleccionar la flor */}
                            <div className="w-full md:w-1/6 mb-6 md:mb-0">
                                <div className="relative">
                                    <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            name="flor"
                                            onChange={onChange}>
                                        <option value="0">Ninguno</option> {/** <--- Valor inicial del select */}
                                        {
                                            flores.map((f, i) => {
                                                return (
                                                    <option key={keyGet()} value={f.id}>{ f.nombre_comun }</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 20 20">
                                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="w-1/6 mx-2 my-1">
                                <button
                                    className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow focus:outline-none">
                                    Agregar
                                </button>
                            </div>
                            <div className="w-1/4 mx-2 my-1">
                                {/* Recalcular el Plan de Siembra*/}
                                <button type="button" className="text-sm bg-indigo-800 hover:bg-indigo-700 text-white mr-2 py-2 px-4 rounded shadow focus:outline-none"
                                        onClick={() => getPlanData()}>
                                    <i className="fas fa-sync-alt" /> Recalcular Totales
                                </button>
                                <button type="button" className="text-sm bg-green-800 hover:bg-green-700 text-white py-2 px-4 rounded shadow focus:outline-none"
                                        onClick={recalcularPlanSiembra}>
                                    <i className="fas fa-sync-alt" /> Regenerar Plan Siembra
                                </button>
                            </div>
                        </div>
                    </form>
                    {/* ---- Planes por año --- */}
                    {
                        planes.map((p, x) => {
                            return ( p.flores.length > 0 && /* solo aquellos años que tengan flores */
                                <>
                                    <h3 key={keyGet()} className="mx-1 my-1 font-bold text-orange-900 mt-3">Año {p.year}</h3>
                                    <p className="font-bold text-blue-900">NOTA: La Unidad de Medida es en Millares para el nivel de flor, los porcentajes de las variedades y colores son porcentajes (1 al 100)</p>
                                    <div id={x} className="w-full shadow-xl rounded m-auto">
                                        <div key={keyGet()} className="wrapper">
                                            <table key={keyGet()} className="table-auto mb-3">
                                                <thead>
                                                    <tr key={keyGet()} className="bg-orange-900 text-white">
                                                        <th className="text-center text-sm w-32 border border-orange-900 bg-orange-900 px-2 my-px sticky-col first-col">
                                                            Flor
                                                        </th>
                                                        <th className="text-center text-sm w-32 border border-orange-900 bg-orange-900 px-2 my-px sticky-col second-col">
                                                            Totales
                                                        </th>
                                                        {[...Array(53)].map((x, i) => {
                                                            return (
                                                                <th key={keyGet()}
                                                                    className="bg-orange-900 border-orange-900 text-center text-sm text-white border overflow-hidden px-2 my-px"
                                                                >
                                                                    {(i + 1 + "").padStart(2, "0")}
                                                                </th>
                                                            );
                                                        })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {p.flores.map((f,j) => {
                                                    return (
                                                        <>
                                                            <tr key={keyGet()}>
                                                            <td className="w-32 text-sm text-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col first-col">
                                                                { f.flor }
                                                                <div key={j+"rr"+keyGet()}>
                                                                    <button className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 ml-2 mr-1 rounded shadow focus:outline-none"
                                                                        onClick={() => updateShowVar(x, j)}>
                                                                        <i className="fas fa-percentage"/> Variedades
                                                                    </button>
                                                                    <button className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 rounded shadow focus:outline-none"
                                                                            onClick={() => showRemoverMdl(f, p.year)}>
                                                                        <i className="fas fa-trash-alt"/> Remover
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td className="w-32 text-sm text-right text-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col second-col">
                                                                {new Intl.NumberFormat().format(f.totalFlor * 1000)}
                                                            </td>
                                                            {f.semanas.map((s,k) => {
                                                                return (
                                                                    <td className="text-center text-sm text-orange-900 font-bold border overflow-hidden px-2 my-px py-1"
                                                                        key={keyGet()}>
                                                                        <CantidadFlorPlan cantidad={s.cantidad} idreg={s.id} i={j} j={k}  fn={modificarTotalesFlor}/>
                                                                    </td>
                                                                )
                                                            })}
                                                            </tr>
                                                            {/* mapear las variedades */}
                                                            {f.show && f.variedades.map((v, l) => {
                                                                return (
                                                                    <>
                                                                    <tr key={keyGet()}>
                                                                        <td className="w-32 text-sm text-green-900 bg-green-100 font-bold px-2 my-px sticky-col first-col">
                                                                            {" "} <i className="fas fa-caret-right" /> {v.nombre}
                                                                            <button className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 ml-2 mr-1 rounded shadow focus:outline-none"
                                                                                    onClick={() => updateShowCol(x,j,l)}>
                                                                                <i className="fas fa-percentage"/> Colores
                                                                            </button>
                                                                        </td>
                                                                        <td className="w-32 text-sm text-green-900 bg-green-100 font-bold px-2 my-px sticky-col second-col">
                                                                            {""}
                                                                        </td>
                                                                        {v.porcentajes.map((p,m) => {
                                                                            return (
                                                                                <td className="text-right text-sm bg-green-100 font-bold px-2 my-px" key={keyGet()}>
                                                                                    <PorcentajeVariedad cantidad={p.porcentaje} idreg={p.id} />
                                                                                </td>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                    {/* mapear los colores */}
                                                                    {v.show && (v.colores.length ? v.colores.map((c,m) => {
                                                                        return (
                                                                            <tr key={keyGet()}>
                                                                                <td className="w-32 text-sm text-indigo-900 bg-indigo-100 font-bold px-2 my-px sticky-col first-col">
                                                                                    - {c.color}
                                                                                </td>
                                                                                <td className="w-32 text-sm text-indigo-900 bg-indigo-100 font-bold px-2 my-px sticky-col second-col">
                                                                                    {""}
                                                                                </td>
                                                                                {
                                                                                    c.porcentajes.map((pc, o) => {
                                                                                        return (
                                                                                            <td className="text-right text-sm bg-indigo-100 font-bold px-2 my-px" key={ keyGet()}>
                                                                                                <PorcentajeColor cantidad={pc.porcentaje} idreg={pc.id} />
                                                                                            </td>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tr>
                                                                        )
                                                                    }): (
                                                                        <tr key={keyGet()}>
                                                                            <td className="w-32 text-sm text-red-900 bg-red-100 font-bold p-2 my-px sticky-col first-col"
                                                                                colSpan="2">
                                                                                No Hay colores definidos para esta variedad
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </>
                                                                )
                                                            })}
                                                        </>
                                                    )
                                                })}
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td className="w-32 text-sm text-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col first-col"> </td>
                                                    <td className="w-32 font-bold text-sm text-right text-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col second-col">Totales:</td>
                                                    {p.totalesVertical.map((z, i) => {
                                                       return (
                                                           <td className="p-2 text-right font-bold text-blue900 border bg-blue-100" key={keyGet()}>{new Intl.NumberFormat().format(z * 1000)}</td>
                                                       )
                                                    })}
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </div>
        </div>
        {loader && <MyLoader/>}

        <Modal
            titulo="Remover Flor del Plan"
            mensaje={`¿Seguro de Remover la flor seleccionada?`}
            ref={modalRef}
            actionTitle="Remover"
            actionFn={remover}
        />
    </>
    );
}

export default FlorPlanporcentajes;
